/* nazifa-series-shopper build: 2026-08-09-per-row-atc */
(() => {
  const roots = document.querySelectorAll('[data-nazifa-shopper]');
  if (!roots.length) return;

  const cartAddUrl = () => {
    const themeRoute = window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url;
    if (themeRoute) return themeRoute;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root}cart/add.js`;
  };

  const cartJsonUrl = () => {
    const themeRoute = window.Theme && window.Theme.routes && window.Theme.routes.cart_url;
    if (themeRoute) return `${String(themeRoute).replace(/\/$/, '')}.js`;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root}cart.js`;
  };

  function skuSpecsScriptSrc() {
    const shopper = document.querySelector('script[src*="nazifa-series-shopper.js"]');
    if (shopper && shopper.src) {
      return shopper.src.replace('nazifa-series-shopper.js', 'nazifa-sku-specs.js');
    }
    return (
      (window.Shopify && window.Shopify.cdnHost ? `https://${window.Shopify.cdnHost}` : '') +
      '/cdn/shop/t/15/assets/nazifa-sku-specs.js'
    );
  }

  function loadSkuSpecs() {
    if (window.NAZIFA_SKU_SPECS) return Promise.resolve();
    const existing = document.querySelector('script[data-nazifa-sku-specs], script[src*="nazifa-sku-specs.js"]');
    if (existing) {
      return new Promise((resolve) => {
        if (window.NAZIFA_SKU_SPECS) return resolve();
        existing.addEventListener('load', () => resolve(), { once: true });
        window.setTimeout(resolve, 800);
      });
    }
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = skuSpecsScriptSrc();
      script.defer = true;
      script.dataset.nazifaSkuSpecs = '1';
      script.onload = () => resolve();
      script.onerror = () => resolve();
      document.head.appendChild(script);
    });
  }

  function optionSku(option) {
    const direct = (option.dataset.sku || '').trim();
    if (direct) return direct;
    const small = option.querySelector('small');
    const fromSmall = (small && small.textContent ? small.textContent : '').trim();
    if (fromSmall) return fromSmall.split('·')[0].trim();
    const price = option.dataset.price || '';
    const match = price.match(/^([A-Za-z0-9][A-Za-z0-9._()-]*)\s*[·•]/);
    return match ? match[1] : '';
  }

  function ensureSpecsUi(root) {
    let specsEl = root.querySelector('[data-shopper-specs]');
    if (!specsEl) {
      const wrap = document.createElement('div');
      wrap.className = 'nazifa-shopper__specs';
      wrap.setAttribute('data-shopper-specs', '');
      wrap.hidden = true;
      wrap.innerHTML =
        '<p class="nazifa-shopper__bom-title">Product facts</p>' +
        '<dl class="nazifa-shopper__specs-grid" data-shopper-specs-body></dl>' +
        '<p class="nazifa-shopper__specs-note" data-shopper-specs-note hidden></p>';
      const desc = root.querySelector('[data-shopper-desc]');
      const cta = root.querySelector('.nazifa-shopper__cta');
      if (desc && desc.parentNode) desc.insertAdjacentElement('afterend', wrap);
      else if (cta) cta.insertBefore(wrap, cta.firstChild);
      else root.appendChild(wrap);
      specsEl = wrap;
    }
    return {
      specsEl,
      specsBody: root.querySelector('[data-shopper-specs-body]'),
      specsNote: root.querySelector('[data-shopper-specs-note]'),
    };
  }

  function cartSectionIds() {
    const ids = [];
    document.querySelectorAll('cart-items-component').forEach((el) => {
      const id = el instanceof HTMLElement ? el.dataset.sectionId : '';
      if (id && !ids.includes(id)) ids.push(id);
    });
    if (!ids.length) ids.push('cart-drawer-section');
    return ids;
  }

  function variantGid(id) {
    const n = String(id).replace(/\D/g, '');
    return n ? `gid://shopify/ProductVariant/${n}` : '';
  }

  async function addViaShopifyActions(items) {
    const updateCart = window.Shopify && window.Shopify.actions && window.Shopify.actions.updateCart;
    if (typeof updateCart !== 'function') return null;
    const lines = items
      .map((item) => ({
        merchandiseId: variantGid(item.id),
        quantity: Math.max(1, Number(item.quantity) || 1),
      }))
      .filter((line) => line.merchandiseId);
    if (!lines.length) throw new Error('Missing variant id');
    return updateCart({ lines }, { event: { context: 'product' } });
  }

  async function addViaAjax(items) {
    const sections = cartSectionIds().join(',');
    const res = await fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) {
      const msg = data.description || data.message || data.errors || 'Could not add to cart';
      throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
    }
    return data;
  }

  async function addToCart(items) {
    if (window.Shopify && window.Shopify.actions && typeof window.Shopify.actions.updateCart === 'function') {
      const data = await addViaShopifyActions(items);
      return { via: 'actions', data };
    }
    const data = await addViaAjax(items);
    return { via: 'ajax', data };
  }

  function updateCartCount(itemCount) {
    if (typeof itemCount !== 'number') return;
    document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden], .cart-bubble-text').forEach((el) => {
      if (el.hasAttribute('data-cart-count') || el.classList.contains('cart-bubble-text')) {
        el.textContent = String(itemCount);
      }
    });
  }

  async function openCartDrawer() {
    const openCart = window.Shopify && window.Shopify.actions && window.Shopify.actions.openCart;
    if (typeof openCart === 'function') {
      try {
        await openCart();
        return;
      } catch (_) {
        /* fall through */
      }
    }
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    const trigger = document.querySelector('[aria-controls="cart-drawer"]');
    if (trigger) trigger.click();
  }

  async function refreshCartUi(result) {
    if (result.via === 'ajax') {
      const sections = (result.data && result.data.sections) || {};
      for (const [sectionId, html] of Object.entries(sections)) {
        if (!html) continue;
        const current = document.getElementById(`shopify-section-${sectionId}`);
        if (!current) continue;
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const next = tmp.querySelector(`#shopify-section-${sectionId}`) || tmp.firstElementChild;
        if (next) current.replaceWith(next);
      }
    }

    try {
      const cart = await fetch(cartJsonUrl(), {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      }).then((r) => r.json());
      updateCartCount(cart.item_count);
    } catch (_) {
      /* ignore */
    }

    await openCartDrawer();
  }

  function rowQty(option) {
    const input = option.querySelector('[data-shopper-row-qty]');
    return Math.max(1, Math.min(99, Number(input && input.value) || 1));
  }

  function isBuyControl(target) {
    if (!(target instanceof Element)) return false;
    return Boolean(
      target.closest(
        '[data-shopper-row-atc], [data-shopper-qty-root], [data-shopper-row-qty], [data-shopper-qty-minus], [data-shopper-qty-plus]'
      )
    );
  }

  function initShopper(root) {
    if (root.dataset.shopperBound === '1') return;
    root.dataset.shopperBound = '1';

    const media = root.querySelector('[data-shopper-media]');
    const img = root.querySelector('[data-shopper-img]');
    const titleEl = root.querySelector('[data-shopper-title]');
    const priceEl = root.querySelector('[data-shopper-price]');
    const descEl = root.querySelector('[data-shopper-desc]');
    const bomEl = root.querySelector('[data-shopper-bom]');
    const bomBody = root.querySelector('[data-shopper-bom-body]');
    const { specsEl, specsBody, specsNote } = ensureSpecsUi(root);
    const details = root.querySelector('[data-shopper-details]');
    const status = root.querySelector('[data-shopper-status]');
    const options = [...root.querySelectorAll('[data-shopper-option]')];

    if (!options.length) return;

    let active = options.find((o) => o.getAttribute('aria-selected') === 'true') || options[0];

    const label = (key, fallback) => root.dataset[key] || fallback;

    function yn(value) {
      if (value === true || value === 'yes' || value === 'true') return label('labelYes', 'Yes');
      if (value === false || value === 'no' || value === 'false') return label('labelNo', 'No / confirm SKU');
      return '';
    }

    function lookupSpecs(option) {
      const sku = optionSku(option);
      if (sku && !option.dataset.sku) option.dataset.sku = sku;
      const map = window.NAZIFA_SKU_SPECS || {};
      const fromMap = (sku && (map[sku] || map[sku.toUpperCase()] || map[sku.toLowerCase()])) || {};
      return {
        sku,
        series: fromMap.series || '',
        dimensions: option.dataset.dimensions || fromMap.dimensions || '',
        pack: fromMap.pack || '',
        weight: option.dataset.weight || (fromMap.weight_g ? `${fromMap.weight_g} g` : ''),
        craft: option.dataset.craft || fromMap.craft || '',
        material: fromMap.material || 'Ceramic',
        microwave: option.dataset.microwave || fromMap.microwave,
        oven: option.dataset.oven || fromMap.oven,
        dishwasher: option.dataset.dishwasher || fromMap.dishwasher,
        care_note: fromMap.care_note || '',
      };
    }

    function renderSpecs(option) {
      if (!specsEl || !specsBody) return;
      const s = lookupSpecs(option);
      const rows = [
        [label('labelSeries', 'Series'), s.series],
        [label('labelDimensions', 'Size'), s.dimensions && s.dimensions !== '/' ? s.dimensions : ''],
        [label('labelPack', 'Pack'), s.pack && s.pack !== '/' ? s.pack : ''],
        [label('labelWeight', 'Weight'), s.weight],
        [label('labelCraft', 'Craft'), s.craft],
        [label('labelMaterial', 'Material'), s.material],
        [label('labelMicrowave', 'Microwave'), yn(s.microwave)],
        [label('labelOven', 'Oven'), yn(s.oven)],
        [label('labelDishwasher', 'Dishwasher'), yn(s.dishwasher)],
      ].filter(([, v]) => v);

      if (!rows.length) {
        specsEl.hidden = true;
        specsBody.innerHTML = '';
        if (specsNote) {
          specsNote.hidden = true;
          specsNote.textContent = '';
        }
        return;
      }

      specsBody.innerHTML = rows
        .map(
          ([k, v]) =>
            `<div class="nazifa-shopper__spec"><dt>${k}</dt><dd>${String(v)
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')}</dd></div>`
        )
        .join('');
      specsEl.hidden = false;
      if (specsNote) {
        if (s.care_note) {
          specsNote.hidden = false;
          specsNote.textContent = s.care_note;
        } else {
          specsNote.hidden = true;
          specsNote.textContent = '';
        }
      }
    }

    function setStatus(message, isError = false) {
      if (!status) return;
      status.hidden = !message;
      status.textContent = message || '';
      status.classList.toggle('is-error', Boolean(isError));
    }

    function applyStage(option, { animate = true } = {}) {
      if (!option) return;
      active = option;
      options.forEach((o) => o.setAttribute('aria-selected', o === option ? 'true' : 'false'));

      const thumb = option.querySelector('img');
      const src = option.dataset.image || thumb?.currentSrc || thumb?.src || '';
      const title = option.dataset.title || '';
      const price = option.dataset.price || option.dataset.priceLabel || '';
      const desc = option.dataset.description || '';
      const url = option.dataset.url || '#';
      const bom = option.dataset.bom || '';

      if (img && src) {
        const nextSrc = src;
        const abs = new URL(src, window.location.href).href.split('?')[0];
        const cur = (img.currentSrc || img.src || '').split('?')[0];
        const changed = cur !== abs;
        if (animate && changed) {
          media?.classList.add('is-switching');
          window.setTimeout(() => {
            img.src = nextSrc;
            img.alt = title;
            media?.classList.remove('is-switching');
          }, 160);
        } else {
          img.src = nextSrc;
          img.alt = title;
          if (animate) {
            media?.classList.add('is-switching');
            window.setTimeout(() => media?.classList.remove('is-switching'), 120);
          }
        }
        img.hidden = false;
        const empty = media?.querySelector('[data-shopper-empty-media]');
        if (empty) empty.hidden = true;
      }

      if (titleEl) titleEl.textContent = title;
      if (priceEl) priceEl.textContent = price;
      if (descEl) descEl.textContent = desc;
      if (details) {
        details.setAttribute('href', url);
        details.hidden = !url || url === '#';
      }

      renderSpecs(option);

      if (bomEl && bomBody) {
        if (bom.trim()) {
          bomBody.textContent = bom;
          bomEl.classList.add('is-open');
        } else {
          bomBody.textContent = '';
          bomEl.classList.remove('is-open');
        }
      }
    }

    async function runAdd(items, busyEl) {
      setStatus('');
      busyEl?.classList.add('is-busy');
      busyEl?.setAttribute('aria-busy', 'true');
      try {
        const result = await addToCart(items);
        await refreshCartUi(result);
        const n = items.reduce((sum, item) => sum + item.quantity, 0);
        setStatus(root.dataset.addedMessage?.replace('{{ count }}', String(n)) || `Added ${n} item(s) to cart`);
      } catch (err) {
        setStatus((err && err.message) || 'Could not add to cart', true);
      } finally {
        busyEl?.classList.remove('is-busy');
        busyEl?.removeAttribute('aria-busy');
      }
    }

    options.forEach((option) => {
      const qtyInput = option.querySelector('[data-shopper-row-qty]');
      const minus = option.querySelector('[data-shopper-qty-minus]');
      const plus = option.querySelector('[data-shopper-qty-plus]');
      const rowAtc = option.querySelector('[data-shopper-row-atc]');
      const selectBtn = option.querySelector('[data-shopper-select]');

      minus?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!qtyInput || qtyInput.disabled) return;
        qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1) - 1));
        applyStage(option, { animate: false });
      });

      plus?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!qtyInput || qtyInput.disabled) return;
        qtyInput.value = String(Math.min(99, Number(qtyInput.value || 1) + 1));
        applyStage(option, { animate: false });
      });

      qtyInput?.addEventListener('click', (event) => event.stopPropagation());
      qtyInput?.addEventListener('change', () => {
        if (!qtyInput) return;
        qtyInput.value = String(Math.max(1, Math.min(99, Number(qtyInput.value || 1))));
      });

      rowAtc?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        applyStage(option, { animate: false });
        if (option.getAttribute('aria-disabled') === 'true') {
          setStatus(root.dataset.unavailableMessage || 'This item is unavailable', true);
          return;
        }
        const id = Number(option.dataset.variantId);
        if (!id) {
          setStatus(root.dataset.unavailableMessage || 'This item is unavailable', true);
          return;
        }
        runAdd([{ id, quantity: rowQty(option) }], rowAtc);
      });

      selectBtn?.addEventListener('click', (event) => {
        event.preventDefault();
        applyStage(option);
      });

      option.addEventListener('mouseenter', () => {
        if (!window.matchMedia('(hover: hover)').matches) return;
        applyStage(option);
      });

      option.addEventListener('click', (event) => {
        if (isBuyControl(event.target)) return;
        if (event.target.closest('[data-shopper-select]')) return;
        applyStage(option);
      });

      option.addEventListener('keydown', (event) => {
        if (isBuyControl(event.target)) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          applyStage(option);
        }
      });

      option.addEventListener('focus', () => applyStage(option, { animate: false }));
    });

    applyStage(active, { animate: false });
  }

  function boot() {
    loadSkuSpecs().then(() => {
      document.querySelectorAll('[data-nazifa-shopper]').forEach(initShopper);
    });
  }

  boot();

  document.addEventListener('nazifa:shopper-hydrated', boot);
  const main = document.getElementById('MainContent');
  if (main && !window.__NAZIFA_SHOPPER_MO) {
    window.__NAZIFA_SHOPPER_MO = new MutationObserver(() => {
      const unbound = main.querySelector('[data-nazifa-shopper]:not([data-shopper-bound="1"])');
      if (unbound) boot();
    });
    window.__NAZIFA_SHOPPER_MO.observe(main, { childList: true, subtree: true });
  }
})();
